export enum FormStatus {
  KO_FORM_CONSTRAINTS = 'KO_FORM_CONSTRAINTS',
  KO_WORKFLOW = 'KO_WORKFLOW',
  KO_TOKEN = 'KO_TOKEN',
  OK = 'OK',
}
